import { Navigate, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import Alerts from "./components/Alerts";
import { AppointmentLayout } from "./components/AppointmentLayout";
import { DashboardLayout } from "./components/DashboardLayout";
import DevicesPanel from "./components/DevicesPanel";
import EmergencyVisit from "./components/EmergencyVisit";
import { Header } from "./components/Header";
import { Login } from "./components/LoginPage";
import { MainLayout } from "./components/MainLayout";
import NoShowActivityDetail from "./components/NoShow/NoShowActivityDetail";
import NoShowDetail from "./components/NoShow/NoShowDetail";
import NoShowTable from "./components/NoShow/NoShowTable";
import { NoShowLayout } from "./components/NoShowLayout";
import PatientDetails from "./components/PatientDetail";
import { PatientLayout } from "./components/PatientLayout";
import { PatientLogin } from "./components/PatientLogin";
import { PostDischargeLayout } from "./components/PostDischargeLayout";
import { ProcedureUplift } from "./components/ProcedureUplift";
import Providers from "./components/Providers";
import { ReferralLayout } from "./components/ReferralLayout";
import { RoleSelector } from "./components/RoleSelector";
import { AuthProvider } from "./context/AuthContext";
import { CarePlanLayout } from "./patientModule/CareplanLayout";
import { CaretakerLayout } from "./patientModule/CaretakerLayout";
import CommunicationLayout from "./patientModule/CommunicationLayout";
import { ConciergesLayout } from "./patientModule/ConciergesLayout";
import DischargeDetails from "./patientModule/DischargeDetails";
import { DoctorList } from "./patientModule/DoctorList";
import DoctorsProfileLayout from "./patientModule/DoctorsProfile";
import HealthLayout from "./patientModule/HealthLayout";
import { PatientAppointmentLayout } from "./patientModule/PatientAppointmentLayout";
import { PatientDashboardLayout } from "./patientModule/PatientDashboardLayout";
import PatientDischarge from "./patientModule/PatientDischarge";
import { PatientReferral } from "./patientModule/pages/PatientReferral";
import { ProfileLayout } from "./patientModule/ProfileLayout";
import { UserLayout } from "./patientModule/UserLayout";
import { PatientReferralTo } from "./patientModule/pages/PatientReferralTo";
import { ReferralAppointment } from "./patientModule/pages/ReferralAppointment";
import ReferralOrder from "./patientModule/pages/ReferralOrder";

function App() {
  return (
    <AuthProvider>
      <Header />
      <Routes>
        <Route path="/" element={<RoleSelector />} />
        <Route path="/provider-login" element={<Login />} />
        <Route path="/patient-login" element={<PatientLogin />} />
        <Route path="/user-layout" element={<UserLayout />}>
          <Route index element={<Navigate to="patient-dashboard" replace />} />
          <Route
            path="patient-dashboard"
            element={<PatientDashboardLayout />}
          />
          <Route
            path="patient-appointment"
            element={<PatientAppointmentLayout />}
          />
          <Route path="doctor-list" element={<DoctorList />} />
          <Route path="doctor-list/:id" element={<DoctorsProfileLayout />} />
          <Route path="my-health" element={<HealthLayout />} />
          <Route path="my-caretaker" element={<CaretakerLayout />} />
          <Route path="my-profile" element={<ProfileLayout />} />
          <Route path="my-concierges" element={<ConciergesLayout />} />
          <Route path="patient-referral" element={<PatientReferral />} />
          <Route path="patient-referral-to" element={<PatientReferralTo />} />
          <Route
            path="referral-appointment"
            element={<ReferralAppointment />}
          />
          <Route path="referral-order" element={<ReferralOrder />} />
          <Route path="patient-referral-to" element={<PatientReferral />} />
          <Route path="patient-discharge" element={<PatientDischarge />} />
          <Route path="care-plan" element={<CarePlanLayout />} />
          <Route path="my-communication" element={<CommunicationLayout />} />
          <Route path="discharge/:id" element={<DischargeDetails />} />
        </Route>
        <Route path="layout" element={<MainLayout />}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<DashboardLayout />} />
          <Route path="appointment" element={<AppointmentLayout />} />
          <Route path="patient" element={<PatientLayout />} />
          <Route path="referral" element={<ReferralLayout />} />
          <Route path="patient-details" element={<PatientDetails />} />
          <Route path="my-devices" element={<DevicesPanel />} />
          <Route path="alerts" element={<Alerts />} />
          <Route path="providers" element={<Providers />} />
          <Route path="my-communication" element={<CommunicationLayout />} />
          <Route path="post-discharge" element={<PostDischargeLayout />} />
          <Route path="discharge/:id" element={<DischargeDetails />} />
          <Route path="procedure-uplift" element={<ProcedureUplift />} />
          <Route path="emergency-visit" element={<EmergencyVisit />} />
          <Route path="noshow" element={<NoShowLayout />}>
            <Route index element={<NoShowTable />} />
          </Route>
          <Route path="noshow/:id" element={<NoShowDetail />} />
          <Route
            path="noshow/activity/:id"
            element={<NoShowActivityDetail />}
          />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ToastContainer />
    </AuthProvider>
  );
}

export default App;
